/**
 * Terms:
 * bhbgc - block-header background-color
 * bha - block header adventure
 * fwb - full width bg
 */

import React from "react";
import { ProductTypeByValue } from "../../../../../part-panel/lib/product-types.js";
import { toElementProps } from "../../Element.js";

export function BlockHeaderECommerceStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;

    return {
        "& .block-header": {
            position: "relative",
            // width: "100vw",
            width: "100%",
            height: "100vh",
            zIndex: 2,
            display: "flex",
            justifyContent: "center",

            paddingTop: "0",
            overflow: "hidden",

            "& > *": {
                position: "relative",
            },

            "& > .bhbgc": {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: palette.primary.initial,
            },

            "& .block-header-bgwrapper": {
                position: "absolute",
                zIndex: 0,
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",

                display: "grid",
                gridTemplateColumns: "1fr",
                justifyContent: "center",
                alignItems: "center",

                backgroundPosition: "bottom center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                [MobileBreakpoint]: {
                    height: "110vh",
                },
            },

            /* Content */
            "& .block-header-content-wrapper": {
                display: "grid",
                gridGap: "40px",
                justifySelf: "center",

                justifyContent: "center",

                width: "100%",
                height: "100%",
                maxWidth: "1200px",
                paddingLeft: "16px",
                paddingRight: "16px",
                paddingTop: "80px",
                zIndex: "2",
            },

            /* Services */
            "& .bha-wrapper": {
                position: "absolute",
                zIndex: 0,
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
                opacity: 1,

                display: "grid",
                gridTemplateColumns: "1fr",
                justifyContent: "center",
                alignItems: "center",

                backgroundPosition: "bottom center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",

                "& .bha": {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                },

                "& .bha:not(.filling-disabled).vertical": {
                    background: palette.primary.initial,
                },

                /* "& .bha.gradient-disabled": {
                    backgroundColor: palette.primary.initial,
                }, */

                "& .bha:not(.gradient-disabled).text-image": {
                    background: `linear-gradient(to left, transparent, ${palette.primary.initial})`,
                },

                "& .bha:not(.gradient-disabled).image-text": {
                    background: `linear-gradient(to right, transparent, ${palette.primary.initial})`,
                },

                "& .gradient-70": {
                    opacity: "70%",
                },

                "& .gradient-100": {
                    opacity: 1,
                },
            },

            "& .down-container": {
                position: "fixed",
                bottom: "0",
                zIndex: 2,

                transition: "all 200ms ease",

                "&.down-hide": {
                    opacity: 0,
                },

                "& .down-go": {
                    background: "#fff",
                    background: `linear-gradient(#fff, ${palette.primary.initial})`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "48px",
                    width: "48px",
                    borderRadius: "50% 50% 0 0",
                    zIndex: 2,
                    cursor: "pointer",

                    "& .down-arrow": {
                        opacity: 1,
                        width: 0,
                        height: 0,
                        borderLeft: "4px solid transparent",
                        borderRight: "4px solid transparent",
                        borderTop: "6px solid black",
                    },
                },
            },

            "&.fbw": {
                [MobileBreakpoint]: {
                    display: "grid",
                    gridTemplateRows: "1fr 0.55fr",
                },
            },

            [MobileBreakpoint]: {
                margin: 0,
                height: "auto",
                overflow: "hidden",

                "& > div": {
                    paddingBottom: 0,
                },

                "& .ignore-by-height": {
                    display: "flex",
                    justifyContent: "center !important",

                    "& img": {
                        width: "100% !important",
                    },
                },

                "& p": {
                    textAlign: "center !important",
                    margin: "0 20px",
                },

                "& button": {
                    width: "100% !important",
                },

                "& .down-container": {
                    display: "none",
                },

                "& .bha-wrapper": {
                    opacity: "1 !important",
                    gridRow: 2,
                    width: "100%",
                    height: "100%",

                    "& .gradient-100, & .gradient-70": {
                        opacity: "0 !important",
                    },
                },
            },
        },
    };
}

export default function BlockHeaderECommerce(props) {
    const refBlockDown = React.useRef(null);
    // Variables ------------------------------------------------------------ //
    const {
        AdventurePictureExample,
        blocks,
        info,
        ProductPicture,
        ProductPictureHideOverlayGradient,
        ProductType,
        svgBg,
    } = props.variables;

    const dbhbgg = props?.variables?.Disabled?.BlockHeaderECommerce?.BGGradient;
    // ---------------------------------------------------------------------- //

    if (!ProductType) {
        throw new Error(`<BlockHeaderECommerce /> Product type is: "${ProductType}"`);
    }

    const {
        images: [productPictureFill],
        variables: { FullWidthBg, EventHeaderECommerce },
    } = ProductTypeByValue[ProductType];

    const anchor = blocks && blocks[1];

    React.useEffect(() => {
        window.addEventListener("scroll", OnWindowScroll);
        window.dispatchEvent(new Event("scroll"));

        return () => {
            window.removeEventListener("scroll", OnWindowScroll);
        };
    }, []);

    function OnWindowScroll() {
        if (!refBlockDown.current) {
            return;
        }

        const domDown = refBlockDown.current;
        domDown.classList[window.scrollY > 0 ? "add" : "remove"]("down-hide");
    }

    const CNBlockHeaderECommerce = ["block-header"];

    const blockHeaderECommerceStyles = {};
    const bgWrapStyles = {};
    if (svgBg) {
        blockHeaderECommerceStyles.backgroundColor = `transparent`;
        bgWrapStyles.backgroundImage = `url(${svgBg})`;
    }

    const bgAdventureStyles = {};
    const CNAdventure = ["bha"];
    CNAdventure.push(info?.BlockHeaderECommerceContentPosition);
    if (dbhbgg) {
        CNAdventure.push("gradient-disabled");
    } else if (ProductPictureHideOverlayGradient) {
        CNAdventure.push("gradient-disabled", "filling-disabled");
    }

    if (FullWidthBg) {
        CNBlockHeaderECommerce.push("fbw");

        bgAdventureStyles.backgroundImage = `url(${
            ProductPicture
                ? ProductPicture[0]?.file?.dataUrlBase64 || ProductPicture[0].src
                : AdventurePictureExample || productPictureFill
        })`;

        if ((props.gradient || info?.gradient) === 1) {
            CNAdventure.push("gradient-100");
        } else {
            CNAdventure.push("gradient-70");
        }
    }

    const elProps = toElementProps(props, { className: CNBlockHeaderECommerce, style: blockHeaderECommerceStyles });
    return (
        <div {...elProps}>
            <div className="block-header-bgwrapper" style={bgWrapStyles}></div>
            <div className="block-header-content-wrapper">{props.children}</div>
            {dbhbgg && <div className="bhbgc" />}

            {FullWidthBg && (
                <div className="bha-wrapper" style={bgAdventureStyles}>
                    <div className={CNAdventure.join(" ")}></div>
                </div>
            )}

            {!EventHeaderECommerce && (
                <div ref={refBlockDown} className="down-container">
                    {anchor && (
                        <div className="down-go" onClick={() => (window.location = `#${anchor}`)}>
                            <span className="down-arrow"></span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
